export const resIitialState = {
    resList: []
};